export default "__VITE_ASSET__BJhCyLoo__"